import { useEffect } from 'react';
import { findemWidgetEventNames } from 'helpers/findemWidget';
import { updateJobSourcingCampaign } from 'hooks/useJobs/actions';
import { useDispatch } from 'react-redux';
import { useUpdateSourcingCampaignMutation } from 'services/findemV2';
import { useCampaignPolling } from './useCampaignPolling';

export const useFindemEvents = () => {
  const dispatch = useDispatch();
  const [updateSourcingCampaign] = useUpdateSourcingCampaignMutation();
  const startPolling = useCampaignPolling();

  useEffect(() => {
    const handleCreateCampaign = async (event) => {
      const { payload } = event.detail;
      if (payload.job_id) {
        await updateSourcingCampaign({
          id: payload.sourcing_campaign_id,
          status: 'in_progress',
        });

        dispatch(
          updateJobSourcingCampaign({
            jobId: parseInt(payload.job_id, 10),
            sourcingCampaign: { status: 'in_progress' },
          }),
        );
      }
    };

    const handleSessionChange = (event) => {
      const { payload } = event.detail;
      if (payload.job_id) {
        const updatePayload = {
          id: payload.sourcing_campaign_id,
          sessionId: payload.sessionId,
          agentId: payload.agentId,
        };

        updateSourcingCampaign(updatePayload);
        dispatch(
          updateJobSourcingCampaign({
            jobId: parseInt(payload.job_id, 10),
            sourcingCampaign: updatePayload,
          }),
        );
      }
    };

    const handleCalibrationCompleted = async (event) => {
      const { payload } = event.detail;
      if (payload.job_id && payload.sourcing_campaign_id) {
        await updateSourcingCampaign({
          id: payload.sourcing_campaign_id,
          status: 'calibrating',
        });
        dispatch(
          updateJobSourcingCampaign({
            jobId: parseInt(payload.job_id, 10),
            sourcingCampaign: { status: 'calibrating' },
          }),
        );

        // Start polling for this campaign
        startPolling(payload.sourcing_campaign_id, parseInt(payload.job_id, 10));
      }
    };

    window.addEventListener(findemWidgetEventNames.FINDEM_WIDGET_CREATE_CAMPAIGN, handleCreateCampaign);
    window.addEventListener(findemWidgetEventNames.FINDEM_WIDGET_SESSION_CHANGE, handleSessionChange);
    window.addEventListener(findemWidgetEventNames.FINDEM_WIDGET_CALIBRATION_COMPLETED, handleCalibrationCompleted);

    return () => {
      window.removeEventListener(findemWidgetEventNames.FINDEM_WIDGET_CREATE_CAMPAIGN, handleCreateCampaign);
      window.removeEventListener(findemWidgetEventNames.FINDEM_WIDGET_SESSION_CHANGE, handleSessionChange);
      window.removeEventListener(
        findemWidgetEventNames.FINDEM_WIDGET_CALIBRATION_COMPLETED,
        handleCalibrationCompleted,
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
